import React, { Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import _map from 'lodash/map';

import NotificationApp from './components/notification';
import CurationApp from './components/curation';
import AnalyticsApp from './components/analytics';
import ActiveSection from './components/active_section';
import Settings from './components/settings';
import DemoArticles from './components/demo_articles';
import LiveActivities from './components/live-activities';
import AppleNews from './components/apple-news';

const NewsletterContainer = React.lazy(() => import('./components/newsletter'));
const NewsletterV2Container = React.lazy(() => import('./components/newsletter-v2'));
const HomePageContainer = React.lazy(() => import('./views/HomePage'));
const AdminPageContainer = React.lazy(() => import('./views/AdminPage'));
const FusionSettingsContainer = React.lazy(() => import('./components/fusion-settings'));
const InkBlogContainer = React.lazy(() => import('./components/inkblog'));
const SwipeableContainer = React.lazy(() => import('./components/swipeable'));
const DeletedContentContainer = React.lazy(() => import('./components/deleted-content'));
const PagebuilderPublisherContainer = React.lazy(() => import('./components/pagebuilder-publisher'));
const NotificationAssistantContainer = React.lazy(() => import('./components/notification-assistant'));
const FeaturedStoriesContainer = React.lazy(() => import('./components/featured-stories'));
const FeedConfigList = React.lazy(() => import('./components/newsletter-v2/feed-config'));

const PaywallSetupRedirect = () => {
  const location = useLocation();
  const suffix = location.pathname.replace(/^\/paywall-setup/, '');

  return (
    <Navigate
      to={`/inkbox-v2/paywall-setup${suffix}${location.search}`}
      replace
    />
  );
};

export const tabs = [
  {
    path: "/home",
    component: () => (
      <Suspense fallback={<div>Loading....</div>}>
        <HomePageContainer />
      </Suspense>
    )
  },
  {
    path: "/notifications/*",
    component: NotificationApp,
  },
  ...(
    _map(['/original', '/alert', '/curated', '/ads'], (path) => (
      {
        path: `/inkbox${path}/*`,
        component: () => (
          <Suspense fallback={<div>Loading....</div>}>
            <NewsletterContainer />
          </Suspense>
        )
      }
    ))
  ),
  ...(
    _map(['/original', '/alert', '/curated', '/ads', '/marketing', '/paywall-setup'], (path) => (
      {
        path: `/inkbox-v2${path}/*`,
        component: () => (
          <Suspense fallback={<div>Loading....</div>}>
            <NewsletterV2Container path={path} />
          </Suspense>
        )
      }
    ))
  ),
  {
    path: "/paywall-setup/*",
    component: PaywallSetupRedirect,
  },
  {
    path: "/curations/*",
    component: CurationApp,
  },
  {
    path: "/analytics",
    component: AnalyticsApp
  },
  {
    path: "/settings",
    component: Settings
  },
  {
    path: "/sections",
    component: ActiveSection
  },
  {
    path: "/demo-articles",
    component: DemoArticles
  },
  {
    path: '/weekend-note',
    component: () => (
      <Suspense fallback={<div>Loading....</div>}>
        <FusionSettingsContainer />
      </Suspense>
    )
  },
  {
    path: '/deleted-content',
    component: () => (
      <Suspense fallback={<div>Loading....</div>}>
        <DeletedContentContainer />
      </Suspense>
    )
  },
  {
    path: "/live-activities",
    component: LiveActivities
  },
  {
    path: '/pb-scheduler',
    component: () => (
      <Suspense fallback={<div>Loading....</div>}>
        <PagebuilderPublisherContainer />
      </Suspense>
    )
  },
  {
    path: '/ink-blog/*',
    component: () => (
      <Suspense fallback={<div>Loading....</div>}>
        <InkBlogContainer />
      </Suspense>
    )
  },
  {
    path: '/swipeable/*',
    component: () => (
      <Suspense fallback={<div>Loading....</div>}>
        <SwipeableContainer />
      </Suspense>
    )
  },
  {
    path: "/apple-news",
    component: AppleNews
  },
  {
    // Unlinked private route — reachable only by knowing the URL (no nav entry).
    path: '/push-alert-assisted-editing',
    component: () => (
      <Suspense fallback={<div>Loading....</div>}>
        <NotificationAssistantContainer />
      </Suspense>
    )
  },
  {
    path: '/featured-stories/*',
    component: () => (
      <Suspense fallback={<div>Loading....</div>}>
        <FeaturedStoriesContainer />
      </Suspense>
    )
  },
  {
    path: '/admin/feed-config/*',
    component: () => (
      <Suspense fallback={<div>Loading....</div>}>
        <Routes>
          <Route index element={<FeedConfigList />} />
        </Routes>
      </Suspense>
    )
  },
  {
    path: '/admin',
    component: () => (
      <Suspense fallback={<div>Loading....</div>}>
        <AdminPageContainer />
      </Suspense>
    )
  },
];
